const dateTimeFormatter = new Intl.DateTimeFormat("en-US", {
  dateStyle: "short",
  timeStyle: "long",
});

export const formatTimestamp = (timestamp) =>
  dateTimeFormatter.format(timestamp);
